import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

const store = new Vuex.Store({
  
  state: {
    mills: [
      {
        name: 'Paper Corp. - Coffeeville Mill',
        type: 'Preservative Treating',
        coverage: 100,
        counties: 14,
        percentage: 83.2,
        top: '57%',
        left: '53.5%'
      },
      {
        name: 'Bibb County Hardwood, LLC',
        type: 'Preservative Treating',
        coverage: 100,
        counties: 14,
        percentage: 69.2,
        top: '54%',
        left: '42%'
      },
      {
        name: 'Baldwin Pole & Polling Company Inc.',
        type: 'Preservative Treating',
        coverage: 100,
        counties: 14,
        percentage: 95.4,
        top: '44%',
        left: '43.5%'
      },
      {
        name: 'Cochran\'s Logs to Lumber',
        type: 'Preservative Treating',
        coverage: 100,
        counties: 14,
        percentage: 95.4,
        top: '35%',
        left: '63.5%'
      },
      {
        name: 'Cahaba Timber Company, Inc.',
        type: 'Preservative Treating',
        coverage: 100,
        counties: 14,
        percentage: 95.4,
        top: '30%',
        left: '70%'
      },
      {
        name: 'Chattahoochee Veneer',
        type: 'Preservative Treating',
        coverage: 100,
        counties: 14,
        percentage: 75.5,
        top: '34%',
        left: '48%'
      },
      {
        name: 'Paper Corp. - Gulfcrest Mill',
        type: 'Preservative Treating',
        coverage: 100,
        counties: 14,
        percentage: 79.6,
        top: '50%',
        left: '57%'
      },
      {
        name: 'East Alabama Lumber Company',
        type: 'Preservative Treating',
        coverage: 100,
        counties: 14,
        percentage: 95.4,
        top: '52%', 
        left: '73.5%'
      },
      {
        name: 'Paper Corp. - Monroeville Mill',
        type: 'Preservative Treating',
        coverage: 100,
        counties: 14,
        percentage: 75.5,
        top: '53%',
        left: '53.5%'
      },
      {
        name: 'Enterprise Basket',
        type: 'Preservative Treating',
        coverage: 100,
        counties: 14,
        percentage: 95.4,
        top: '40%', 
        left: '58%'
      },
      {
        name: 'Jachin Tie and Timber, LLC',
        type: 'Preservative Treating',
        coverage: 100,
        counties: 14,
        percentage: 95.4,
        top: '62%', 
        left: '33.5%'
      },
      {
        name: 'J W Lassitier Lumber Company',
        type: 'Preservative Treating',
        coverage: 100,
        counties: 14,
        percentage: 95.4,
        top: '47%', 
        left: '64%'
      },
    ],
    indicators: [
      {
        name: 'Context Indicators',
        icon: 'icon-indicator-context.png',
        single: false,
        expanded: true,
        indicators: [
          { name: 'FL%',
            fullname: 'Forest Land',
            image: 'icon-indicator-fl.png',
            thumb: 'thumb-forest-lands.png',
            description: ' Percentage of Forest Land in County',
            calculation: '(1) The number of ATFS certified forest land acres in the county -by- (2) the estimated number of forest land acres owned by family forest land owners in the county.',
            source: 'FIA (AL: 2015 & MS: 2016)',
            card: 'temp-card.png',
            active: true,
            composite: '79.3%',
          },
          { name: 'FFL%', 
            fullname: 'Family Forest Land',
            description: 'Percentage of Family Forest Land in County',
            calculation: '(1) The estimated number of forest land acres (using the FIA definition of forest land) owned by family forest land owners in the county -divided by- (2) The estimated number of forest land acres in the county.',
            source: 'FIA (AL: 2015 & MS: 2016)',
            thumb: 'thumb-family-forest-lands.png',
            image: 'icon-indicator-ffl.png',
            card: 'temp-card.png',
            active: true,
            composite: '54.2%',
          },
          { name: 'CFL%', 
            fullname: 'Certified Forest Land',
            description: 'Percentage of Certified Forest Land in State',
            calculation: '(1) The estimated number of ATFS, SFI, & FSC certified forest land acres in the state -divided by- (2) The estimated number of forest land acres in the state.',
            source: '(1) FSC (2016): https://us.fsc.org/preview.fsc-certified-acres-by-state.a-204.pdf) & ATFS/SFI (2016): http://www.sfiprogram.org/files/pdf/sfi-atfs-stats-20151/) & (2) FIA (AL: 2016 & MS: 2015)',
            thumb: 'thumb-certified-forest-lands.png',
            image: 'icon-indicator-cfl.png',
            card: 'temp-card.png',
            active: true,
            composite: '25.2%',
          },
        ]
      },
      {
        name: 'Core Indicators',
        icon: 'icon-indicator-core.png',
        single: true,
        expanded: true,
        indicators: [
          { name: 'CFFL%', 
            fullname: 'Certified Family Forest Lands',
            description: 'Percentage of Timber Harvests and Thinnings that Comply with Water Quality BMPs in State',
            image: 'icon-indicator-cffl.png',
            thumb: 'thumb-certified-family-forest-lands.png',
            card: 'temp-card.png',
            active: true,
            calculation: '(1) The number of ATFS certified forest land acres in the county -by- (2) the estimated number of forest land acres owned by family forest land owners in the county.',
            source: '(1) ATFS  (2016) & (2) FIA (AL: 2016 & MS: 2015)',
            composite: '<span class="green">25.3%</span>',
          },
          { name: 'WQBMPs', 
            fullname: 'Practices to Protect Water Quality',
            description: 'Percentage of Timber Harvests and Thinnings that Comply with Forest and Soil Protection BMPs in State',
            image: 'icon-indicator-wqbmps.png',
            thumb: 'thumb-practices-to-protect-water-quality.png',
            card: 'temp-card.png',
            active: true,
            calculation: 'The average BMP implementation compliance rate for water quality based BMPs.',
            source: 'AL (2016) and MS (2016) BMP Compliance Reports',
            composite: '<span class="green">96.2%</span>',
          },
          { name: 'F&HSBMPs',
            fullname: 'Practices to Protect Soils and Harvest Sites',
            description: 'Percentage of Timber Harvests and Thinnings that Comply with Forest and Soil Protection BMPs in State',
            image: 'icon-indicator-fhsbmps.png',
            thumb: 'thumb-forest-lands.png',
            card: 'temp-card.png',
            active: true,
            calculation: 'The average BMP implementation compliance rate for water quality based BMPs.',
            source: 'AL (2016) and MS (2016) BMP Compliance Reports',
            composite: '<span class="green">96.7%</span>',
          },
          { name: 'HFRR', 
            fullname: 'Harvested Forestlands Replanted or Regrowing',
            description: 'Percentage of Forest Land Regenerated Seven Years After a Timber Harvest in FIA Unit',
            image: 'icon-indicator-hfrr.png',
            thumb: 'thumb-harvested-forestlands.png',
            card: 'temp-card.png',
            active: true,
            calculation: '(1) the estimated number of forest land acres regenerated within 7 years of a timber harvest in the FIA Unit -divided by- (2) the estimated number of forest land acres harvested within 7 years of a timber harvest in the FIA Unit',
            source: 'FIA (AL: 2016 & MS: 2015)',
            composite: '<span class="green">98.8%</span>',
          },
        ]
      },
      {
        name: 'Opportunity Indicators',
        icon: 'icon-indicator-opp.png',
        single: false,
        expanded: true,
        indicators: [
          {
            name: 'Overview',
            fullname: 'Opportunity Overview',
            image: 'icon-indicator-ests.png',
            active: true
          },
          { name: 'ES&TS', 
            fullname: 'Endangered and Threatened Species',
            description: 'Number of Federal Endangered and Threatened Species Per 1 million acres in the County',
            image: 'icon-indicator-ests.png',
            thumb: 'thumb-endangered.png',
            card: 'temp-card.png',
            active: true,
            calculation: '(1) The number of endangered and threatened species in the county (2) per 1 million acres in the county.',
            source: '(1) Natureserve.org (2017) and (2) FIA (AL: 2016 & MS: 2015)',
            composite: '8.12',
          },
          { name: 'AT RISK SPEC', 
            fullname: 'Federal Species-At-Risk',
            description: 'Number of Federal Endangered Species Act Species-At-Risk Per 1 million acres in the County',
            image: 'icon-indicator-atrisk.png',
            thumb: 'thumb-at-risk.png',
            card: 'temp-card.png',
            active: true,
            calculation: '(1) The number of proposed endangered or threatened species, candidate species, and species of concern under the Federal Endangered Species Act in the county (2) per 1 million acres in the county.',
            source: '(1) Natureserve.org (2017) and (2) FIA (AL: 2016 & MS: 2015)',
            composite: '1.74' 
          },
          { name: '#IN', 
            fullname: 'Number of Invasive Species',
            description: 'Number of Invasive Species Per 1 million forest land acres in the County',
            image: 'icon-indicator-in.png',
            thumb: 'thumb-num-invasive.png',
            card: 'temp-card.png',
            active: true,
            calculation: '(1) The number of different invasive species on forest land in the county (2) per 1 million forest land acres in the county.',
            source: '(1) FIA (AL: 2016 & MS: 2015)',
            composite: '18.55' 
          },
          { name: 'INS', 
            fullname: 'Invasive Species Severity',
            description: 'Percentage of Forest Lands with Invasive Species in the County',
            image: 'icon-indicator-ins.png',
            thumb: 'thumb-invasive.png',
            card: 'temp-card.png',
            active: true,
            calculation: '(1) the estimated number of forest land acres with one or more invasive species in the county -divided by- (2) the estimated number of forest land acres in the county.',
            source: 'FIA (AL: 2016 & MS: 2015)',
            composite: '50.4%' 
          },
          { name: 'TI&D',
            fullname: 'Tree Insects and Diseases', 
            description: 'Number of Biological Tree Damage-Causing Elements on Forest Land in the County',
            image: 'icon-indicator-tid.png',
            thumb: 'thumb-insects.png',
            card: 'temp-card.png',
            active: true,
            calculation: '(1) The number of different biological tree damage-causing elements (e.g., insects, diseases) on forest land in the county (2) per 1 million forest land acres in the county',
            source: 'FIA (AL: 2016 & MS: 2015)',
            composite: '10.36' 
          },
          { name: 'TI&DS',
            fullname: 'Tree Insects and Diseases Severity',
            description: 'Percentage of Trees with Biological Tree Damage-Causing Elements on Forest Land in the County',
            image: 'icon-indicator-tids.png',
            thumb: 'thumb-insects-2.png',
            card: 'temp-card.png',
            active: true,
            calculation: '(1) the estimated number of trees with one or more biological tree damage-causing elements located on forest land in the county -divided by- (2) the estimated number of trees located on forest land in the county.',
            source: 'FIA (AL: 2016 & MS: 2015)',
            composite: '13.8%'
          },
          { name: 'LO65+', 
            fullname: 'Landowners 65 or Older',
            description: 'Percentage of Primary Owners of 10 Or More Acres of Family Forest Lands 65 Years of Age or Older in the State',
            image: 'icon-indicator-lo65.png',
            thumb: 'thumb-65.png',
            card: 'temp-card.png',
            active: true,
            calculation: 'Adding the estimated number of primary owners of 10 or more acres of forest and woodlands in age categories (1) "65-74" to (2) "75+" from the NWOS in the state.',
            source: 'National Woodland Owners Survey (2013)',
            composite: '44.9%' 
          },
          { name: 'ABSENT LO',
            fullname: 'Absentee Landowners',
            description: 'Percentage of 10 or More Acres of Family Forestland That Are Not Within 1 Mile of The Owners’ Primary Residence in the State',
            image: 'icon-indicator-absentlo.png',
            thumb: 'thumb-abandoned.png',
            card: 'temp-card.png',
            active: true,
            calculation: '(1) adding the estimated number of 10 or more acres of family forest and woodland ownerships that are not within 1 mile of ownership’s primary residence, (2) divided by the estimated number of family and woodland ownerships in the state.',
            source: 'National Woodland Owners Survey (2013)',
            composite: '35.9%'
          },
        ]
      }
    ],
    engagements: [
      {
        title: 'Leafy, invasive, irritating kudzu could be NASCAR\'s fuel of the future',
        excerpt: 'The Plant That Ate The South might finally have the ability to do more good than harm. Dr. Rowan Sage, a professor in the Department of Ecology and Evolutionary Biology at the University of Toronto, thinks he has discovered a way to turn that pain-in-the-butt into a way to haul butt. According to Sage\'s study, kudzu might be the next great source for the manufacture of ethanol. Corn, currently the primary source of ethanol production, requires constant attention and perfect conditions to grow and harvest. Kudzu doesn\'t have that problem. "Kudzu ethanol would be just as good as corn ethanol," Sage said via e-mail while attending a biofuel conference in Mexico City. "Kudzu won\'t replace corn but supplement stocks. The greatest significance would be in the South, where kudzu could diversify the bioethanol feedstock for a regional bioethanol refinery. I imagine we would at best be talking a 10 to 20 percent supplement, but this is still significant, especially if the kudzu can be had for minimal input costs."',
        link: 'http://example.com',
        image: 'engagement-kudzu.png',
        indicators: ['#IN', 'INS'],
        heart: false,
        active: false
      },
      {
        title: 'Outdoor Alabama: Gopher Tortoise Program',
        excerpt: 'Gopher tortoises are considered a keystone species of the longleaf pine ecosystem, with many species depending on them for survival or benefitting from their presence. More than 360 species of mammals, birds, reptiles, amphibians, and invertebrates are known to spend all or a portion of their lives in either active or abandoned gopher tortoise burrows. Some species are completely or largely dependent on these burrows for survival.',
        link: 'http://www.outdooralabama.com/gopher-tortoise-program',
        indicators: ['ES&TS', 'AT RISK SPEC'],
        image: 'engagement-tortoise.png',
        heart: false,
        active: false
      },
      {
        title: 'RESTORETHEGULF.GOV Funded Priorities List',
        description: 'The Gulf Coast Ecosystem Restoration Council (Council), through its Initial Funded Priorities List (FPL) approved Dec. 9, 2015, is using funds from the settlement with Transocean Deepwater Inc. to provide near-term, on-the-ground ecosystem benefits, while also conducting planning activities designed to build a foundation for future success as additional funds become available from other parties.',
        link: 'https://www.restorethegulf.gov/council-selected-restoration-component/funded-priorities-list',
        indicators: ['ES&TS', 'INS'],
        image: 'engagement-restore.png',
        heart: false,
        active: false
      },
      {
        title: 'Example engagement',
        description: 'lorem ipsum',
        link: 'http://example.com',
        indicators: ['ES&TS', 'INS'],
        heart: false,
        active: false
      },
      {
        title: 'Example engagement',
        description: 'lorem ipsum',
        link: 'http://example.com',
        indicators: ['ES&TS', 'INS'],
        heart: false,
        active: false
      },
      {
        title: 'Example engagement',
        description: 'lorem ipsum',
        link: 'http://example.com',
        indicators: ['ES&TS', 'INS'],
        heart: false,
        active: false
      }
    ],
    selectedMills: [],
    selectedCounty: 'Mobile County',
    saveForm: false,
    counties: [
        {
            county: 'Greene County',
            state: 'Mississippi',
            indicators: [
                [
                    { metrics: '91.8%' }, // FL%  
                    { metrics: '54.9%' }, // FFL% 
                    { metrics: '19.1%' }, // CFL% 
                ],
                [
                    { metrics: '<div class="green">16.4%</div>' }, // CFFL%  
                    { metrics: '<div class="green">95.5%</div>' }, // WQBMPs  
                    { metrics: '<div class="green">97.4%</div>' }, // F&HSBMPs
                    { metrics: '<div class="green">100.0%</div>' }, // HFRR    
                ],
                [
                    {}, // OVERVIEW
                    { oppText: '12.99', oppLevel: 4 , name: "ES&TS" },
                    { oppText: '2.17', oppLevel: 4 , name: "AT RISK SPEC" },
                    { oppText: '19.53', oppLevel: 3 , name: "#IN" },
                    { oppText: '26.70', oppLevel: 1 , name: "INS" },
                    { oppText: '9.80', oppLevel: 3 , name: "TI&D" },
                    { oppText: '11.3', oppLevel: 1 , name: "TI&DS" },
                    { oppText: '52', oppLevel: 3 , name: "LO65+" },
                    { oppText: '45.9', oppLevel: 4 , name: "ABSENT LO" },
                ]
            ]
        },
        {
            county: 'Mobile County',
            state: 'Alabama',
            indicators: [
                [
                    { metrics: '47.8%' }, // FL%  
                    { metrics: '53.6%' }, // FFL% 
                    { metrics: '27.5%' }, // CFL% 
                ],
                [
                    { metrics: '<div class="red">4.8%</div>' }, // CFFL%  
                    { metrics: '<div class="green">96.5%</div>' }, // WQBMPs  
                    { metrics: '<div class="green">96.4%</div>' }, // F&HSBMPs
                    { metrics: '<div class="green">98.1%</div>' }, // HFRR    
                ],
                [
                    {}, // OVERVIEW
                    { oppText: '7.64', oppLevel: 3 , name: "ES&TS" },
                    { oppText: '0.96', oppLevel: 1 , name: "AT RISK SPEC" },
                    { oppText: '14.04', oppLevel: 2 , name: "#IN" },
                    { oppText: '39.10', oppLevel: 2 , name: "INS" },
                    { oppText: '12.00', oppLevel: 4 , name: "TI&D" },
                    { oppText: '15.70', oppLevel: 4 , name: "TI&DS" },
                    { oppText: '42.20', oppLevel: 2 , name: "LO65+" },
                    { oppText: '32.10', oppLevel: 1 , name: "ABSENT LO" },
                ]
            ]
        }
    ]
  },

  mutations: {
    setSelectedMills(state, data) {
      state.selectedMills = data;
    }
  },

  getters: {
  	getMills(state) {
  		return state.mills
  	},
    getDefaultMills(state) {
      return state.mills.filter(function (mill) {
        return mill.name.indexOf('Paper') !== -1;
      });
    },
    getSelectedMills(state) {
      return state.selectedMills
    },
    getIndicators(state) {
      return state.indicators
    },
    getCounties(state) {
        return state.counties
    },
  }

});

export default store;



// WEBPACK FOOTER //
// ./src/store.js